export enum HELP_ACTION {
    CLICK = 'click',
    HOVER = 'hover',
}

export enum HELP_THEME {
    SIMPLE = 'simple',
    BLUE_LIGHT = 'blue-light',
    BLUE_DARK = 'blue-dark',
    SCHOOL = 'school',
}

export enum HELP_TYPE {
    INFO = 'info',
    QUESTION = 'question',
    QUESTION_SMALL = 'question-small',
    WARNING = 'warning',
    ERROR = 'error',
}

export enum HELP_SIZE {
    SMALL = 's',
    MEDIUM = 'm',
}
